// extracted by mini-css-extract-plugin
export default {"Hero":"Hero_Hero__2aKvT","HeroText":"Hero_HeroText__f+JSh"};